import * as React from "react";
import { Icon } from "@iconify/react";

import firebase from "firebase";
import { removeAllCookies } from "../../../../utils/cookies";
import SocialSignInButtonWithLogo from "../../../../components/buttons/SocialSignInButtonWithLogo";

export interface AppleSignInProps {
  handleCreateCustomToken: any;
  backText: any;
  backColour: any;
}

/* Apple sign in page */
const AppleSignIn: React.FunctionComponent<AppleSignInProps> = ({
  handleCreateCustomToken,
  backText,
  backColour,
}) => {
  const [isLoading, setIsLoading] = React.useState(false);

  const handleLogout = () => {
    firebase
      .auth()
      .signOut()
      .then(() => {
        removeAllCookies();
        localStorage.clear();
        window.location.href = `${process.env.REACT_APP_PRESTO_ACCOUNT_DOMAIN}/accounts/sign-in`;
      })
      .catch((error) => {
        console.error("Logout error", error);
      });
  };

  const handleClick = () => {
    setIsLoading(true);
    const provider = new firebase.auth.OAuthProvider("apple.com");
    provider.addScope("email");
    provider.addScope("name");

    firebase
      .auth()
      .signInWithPopup(provider)
      .then((result: any) => {
        if (result && result.user) {
          firebase.auth().onAuthStateChanged((firebaseUser) => {
            if (firebaseUser) {
              firebaseUser.getIdToken(true).then(async (idToken) => {
                handleCreateCustomToken(idToken);
              });
            }
          });
        }
      })
      .catch((error) => {
        console.error("Apple Sign-In error:", error);
        setIsLoading(false);
      });
  };

  return (
    <SocialSignInButtonWithLogo
      handleClick={handleClick}
      logoSrc={
        <Icon
          icon="ic:baseline-apple"
          style={{
            width: "32px",
            minWidth: "32px",
            height: "32px",
          }}
          color={backText}
        />
      }
      isLoading={isLoading}
      backColour={backColour}
    />
  );
};

export default AppleSignIn;
